import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const Navbar = ({ children }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  background: ${themeGet('colors.background')};
  margin: 0 10px;
  padding: 10px 0;
  grid-template-columns: repeat(3, 1fr);
  position: sticky;
  align-items: center;
  top: 0;
  z-index: 3;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
  display: flex;
  justify-content: center;
`;
